import { render } from "./CIS-Resource-PagedListing-Pagination.vue?vue&type=template&id=454baabc&scoped=true"
import script from "./CIS-Resource-PagedListing-Pagination.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-Pagination.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-Pagination.vue?vue&type=style&index=0&id=454baabc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454baabc"]])

export default __exports__